import React from 'react';

import './App.css';
import {MuiThemeProvider, withStyles} from '@material-ui/core';

import styles from './config/styles';
import ftlabsTheme from './config/ftlabsTheme';

import Popup from './components/popup';
import Hero from './components/hero';
import Status from './components/status';
import AboutUs from './components/aboutUs';
import OpenPositions from './components/openPositions';
import Projects from './components/projects';
import Community from './components/community';
import Footer from './components/footer'
import Articles from './components/Articles'
import {auth} from './config/firebase';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-111379231-1');

class App extends React.Component {  

  constructor(props){
    super(props);
    this.state = {
      popupOpen: false,
      statusUpdate: null,
      user: false
    }
  }
  componentDidMount(){
    ReactGA.pageview("/home");
  }
  componentWillMount() {
    const result = auth().currentUser;
        if (result){
            console.log(result);
            this.setState({user: result});
        };
  }

  handlePopupOpen = () => {
      this.setState({ popupOpen: true });
  };

  handlePopupClose = () => {
      this.setState({ popupOpen: false });
  };

  render() {
    const {classes} = this.props;
    console.log(classes)
    return (
      <MuiThemeProvider theme={ftlabsTheme}>
        {
            this.state.statusUpdate ?  <Status statusUpdate={this.state.statusUpdate} /> : ""
        }
        
        <Hero />
        <AboutUs />  
        <OpenPositions />
        <Projects openPopup={this.handlePopupOpen} />
        <Articles />
        <Community />
        <Footer />
        <Popup popupOpen={this.state.popupOpen} handlePopupClose={this.handlePopupClose} />
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(App);